const featureTest = (property, value) => {
  const el = document.createElement('test');
  const stylePropsOfElement = el.style;
  stylePropsOfElement.cssText = `${property}:${value};`;
  return Boolean(stylePropsOfElement[property]);
};

const cache = {};

export default (property, value) => {
  if (!(property in cache)) {
    cache[property] = featureTest(property, value);
  }
  return cache[property];
};
